import React, { useState } from "react";

import {
    View,
    Platform,
    ScrollView,
    TextStyle,
    StyleSheet,
    ViewStyle,
    Image,
    Text,
    Modal
} from "react-native";
import AppTheme, { dark_yellow } from "../../utils/Theme";
import NavBarTitle from "../../components/NavBar/NavBarTitle";
import i18n, { translate } from "../../utils/Localization/Localization";
import User from "../../data/user/User";
import SafeAreaView from "../../../specific/views/SafeAreaView";
import Divider from "../../designSystem/Divider/Divider";
import Button from "../../designSystem/Button";
import PremiumCell from "./cells/PremiumCell";
import * as Navigation from "../../../specific/utils/Navigation/Navigation";
import { ScreenSubscriptionPaywall } from "../../utils/Constants";
import Style from "../../utils/Style";
import TextInput from "../../designSystem/TextInput/RoundCornerTextInput";
import { PremiumCard } from "../../components/LiliHQ/LHQCreateCode";
import { addSubToUser, getCardWithCode, redeemedPremiumCardInDb } from "../../services/Firebase/Database";
import { openUrl } from "../../utils/WebLink";
import PremiumSubBlock from "../../../specific/screens/Subscription/PremiumSubBlock";
import { PurchasesPackage } from "react-native-purchases";
import { useSpecificSize } from "../../../specific/Theme/SpecificSize";
import PremiumArguments from "../../components/Subscription/PremiumArguments";
import PremiumTeam from "../../components/Subscription/PremiumTeam";
import { EventRegister } from "../../utils/EventListeners";

interface PremiumScreenProps {
    componentId: string;
}

const PremiumScreen = (props: PremiumScreenProps) => {

    const { componentId } = props;

    const appTheme: AppTheme = new AppTheme();
    const user: User = User.getInstance();

    const [showPremiumCardForm, setShowPremiumCardForm] = useState<boolean>(false);
    const [premiumCode, setPremiumCode] = useState<string>("");
    const [premiumCodeError, setPremiumCodeError] = useState<string>("");
    const [premiumCodeRedeemed, setPremiumCodeRedeemed] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [planSelected, setPlanSelected] = useState<PurchasesPackage | null>(null);

    const {
        availableScreenSize
    } = useSpecificSize();

    // Définition de la largeur des blocks
    let blocksWidth: number = availableScreenSize - appTheme.pixelPerfect(20);
    const flexDirection: "row" | "column" = appTheme.getFlexDirectionForSplitScreen();

    let whiteBoxWidth: number = blocksWidth;
    if (whiteBoxWidth > 1536) {
        whiteBoxWidth = 1536;
    }

    const whiteBoxStyle: ViewStyle = {
        width: whiteBoxWidth,
        paddingHorizontal: appTheme.pixelPerfect(10),
        paddingVertical: appTheme.pixelPerfect(10),
        flexDirection: appTheme.getFlexDirectionForSplitScreen(),
        backgroundColor: "#FFFFFF",
        borderRadius: appTheme.pixelPerfect(30),
        overflow: "hidden"
    }

    const sectionTitleStyle: TextStyle = {
        fontSize: Platform.OS === "web" ? appTheme.pixelPerfectForFont(15) : appTheme.pixelPerfectForFont(12),
        color: appTheme.darkBlue,
        textAlign: "center",
        paddingHorizontal: 10
    }

    const sectionBodyStyle: TextStyle = {
        fontFamily: appTheme.primarySemiBoldFont,
        fontSize: Platform.OS === "web" ? appTheme.pixelPerfectForFont(9) : appTheme.pixelPerfectForFont(9),
        color: appTheme.darkBlue,
        paddingHorizontal: appTheme.pixelPerfect(20),
        textAlign: "center"
    }

    let navigate: any = null;
    if (Platform.OS === "web") {
        navigate = Navigation.useNavigate();
    }

    const launchSubscriptionPage = () => {
        Navigation.showModalInView({
            componentId: componentId,
            name: ScreenSubscriptionPaywall,
            passProps: {
                isModal: true
            }
        })
    }

    const onContactRequest = () => {
        openUrl("https://www.lili.cool/fr/contact/");
    }

    // Reddemcard
    const redeemedCard = async () => {
        // On va récupérer le détail de la carte et la valider
        setPremiumCodeError("");
        try {
            if (premiumCode.length > 0) {
                const card: PremiumCard = await getCardWithCode({ code: premiumCode });
                if (card === undefined) {
                    setPremiumCodeError("Aucune carte PREMIUM ne correspond à ce code.");
                } else {
                    if (card.status !== "toBeRedeemed") {
                        setPremiumCodeError("Ce code a déjà été utilisé.");
                    } else {
                        // On va ajouter l'abonnement à l'utilisateur
                        await addSubToUser({ user_id: user.uid, sub_id: card.product_id, duration_in_month: card.duration, origin: card.origin, card_id: card.code, offer: card.offer });
                        await redeemedPremiumCardInDb({ card, user: user });
                        setPremiumCodeRedeemed(true);
                    }
                }
            } else {
                setPremiumCodeError("Veuillez saisir un code");
            }
        } catch (error) {
            setPremiumCodeError("Une erreur est survenue")
        }
    }

    const getCardDetailsModalContent = () => {
        if (showPremiumCardForm === false) {
            return <View />
        }
        const cardTitle = i18n.t("subCards.modal.form.title");
        if (premiumCodeRedeemed === true) {
            return <View style={{ flex: 1, width: appTheme.getFullAppWidth(), backgroundColor: "#00000090", alignItems: "center", justifyContent: "flex-end" }}>
                <View style={[Style.shadowed, { paddingVertical: appTheme.pixelPerfect(30), paddingHorizontal: appTheme.pixelPerfect(20), width: appTheme.getFullAppWidth(), backgroundColor: appTheme.white, alignItems: "center", justifyContent: "flex-end", borderTopEndRadius: appTheme.pixelPerfect(10), borderTopStartRadius: appTheme.pixelPerfect(10) }]}>
                    <Text style={{ fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(12), color: appTheme.darkBlue, paddingVertical: appTheme.pixelPerfect(10), textAlign: "center" }}>{cardTitle}</Text>
                    <Text style={{ fontFamily: appTheme.secondaryFont, fontSize: appTheme.pixelPerfectForFont(10), color: appTheme.darkBlue, paddingBottom: appTheme.pixelPerfect(10), textAlign: "center" }}>{i18n.t("subCards.modal.form.redeemed")}</Text>
                    <Button
                        link={true}
                        isLoading={isLoading}
                        onPress={() => setShowPremiumCardForm(false)}
                        title={i18n.t("subCards.modal.form.close")}
                        style={{ minWidth: appTheme.pixelPerfect(200), marginBottom: appTheme.pixelPerfect(20) }} />
                </View>
            </View>;
        }
        if (user.getPremiumStatus() === "free") {
            let cardSubtitle = i18n.t("subCards.modal.form.body");
            let closeButtonTitle = i18n.t("subCards.modal.form.nothingToDo");
            const errorTextView = premiumCodeError.length === 0 ? <View /> : <Text style={{ fontFamily: appTheme.secondaryFont, fontSize: appTheme.pixelPerfectForFont(10), color: appTheme.errorColor, paddingBottom: appTheme.pixelPerfect(10), textAlign: "center" }}>{premiumCodeError}</Text>;
            return <View style={{ flex: 1, width: appTheme.getFullScreenWidth(), backgroundColor: "#00000090", alignItems: "center", justifyContent: "flex-end" }}>
                <View style={[Style.shadowed, { paddingVertical: appTheme.pixelPerfect(30), paddingHorizontal: appTheme.pixelPerfect(20), width: appTheme.getFullAppWidth(), backgroundColor: appTheme.white, alignItems: "center", justifyContent: "flex-end", borderTopEndRadius: appTheme.pixelPerfect(10), borderTopStartRadius: appTheme.pixelPerfect(10) }]}>
                    <Text style={{ fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(12), color: appTheme.darkBlue, paddingVertical: appTheme.pixelPerfect(10), textAlign: "center" }}>{cardTitle}</Text>
                    <Text style={{ fontFamily: appTheme.secondaryFont, fontSize: appTheme.pixelPerfectForFont(10), color: appTheme.darkBlue, paddingBottom: appTheme.pixelPerfect(10), textAlign: "center" }}>{cardSubtitle}</Text>
                    <TextInput value={premiumCode} onChangeText={(text) => setPremiumCode(text)} style={{ width: appTheme.pixelPerfect(200) }} />
                    {errorTextView}
                    <Button
                        isLoading={isLoading}
                        onPress={() => redeemedCard()}
                        title={i18n.t("subCards.modal.form.active")}
                        style={{ width: appTheme.pixelPerfect(200), marginBottom: appTheme.pixelPerfect(20) }} />
                    <Button
                        link={true}
                        isLoading={isLoading}
                        onPress={() => setShowPremiumCardForm(false)}
                        title={closeButtonTitle}
                        style={{ minWidth: appTheme.pixelPerfect(200), marginBottom: appTheme.pixelPerfect(20) }} />
                </View>
            </View>;
        }
        return <View style={{ flex: 1, width: appTheme.getFullScreenWidth(), backgroundColor: "#00000090", alignItems: "center", justifyContent: "flex-end" }}>
            <View style={[Style.shadowed, { paddingVertical: appTheme.pixelPerfect(30), paddingHorizontal: appTheme.pixelPerfect(20), width: appTheme.getFullAppWidth(), backgroundColor: appTheme.white, alignItems: "center", justifyContent: "flex-end", borderTopEndRadius: appTheme.pixelPerfect(10), borderTopStartRadius: appTheme.pixelPerfect(10) }]}>
                <Text style={{ fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(12), color: appTheme.darkBlue, paddingVertical: appTheme.pixelPerfect(10), textAlign: "center" }}>{cardTitle}</Text>
                <Text style={{ fontFamily: appTheme.secondaryFont, fontSize: appTheme.pixelPerfectForFont(10), color: appTheme.darkBlue, paddingBottom: appTheme.pixelPerfect(10), textAlign: "center" }}>{i18n.t("subCards.modal.already")}</Text>
                <Button
                    link={true}
                    isLoading={isLoading}
                    onPress={() => setShowPremiumCardForm(false)}
                    title={i18n.t("subCards.modal.form.close")}
                    style={{ minWidth: appTheme.pixelPerfect(200), marginBottom: appTheme.pixelPerfect(20) }} />
            </View>
        </View>;
    }

    const renderTeacherSupport = (): React.JSX.Element[] => {
        let teacherSupportCellWidth: number = whiteBoxWidth;
        let percentArgWidth: number = flexDirection === "row" ? teacherSupportCellWidth - appTheme.pixelPerfect(60) : whiteBoxWidth - appTheme.pixelPerfect(30);
        let allLogosWidth: number = flexDirection === "row" ? percentArgWidth / 2 : percentArgWidth;
        const allLogosHeight: number = allLogosWidth * 145 / 1024;
        let argsPaddingHorizontal: number = 0;
        let argsPaddingVertical: number = 0;
        const percentArgUnitWidth: number = percentArgWidth / 3;
        const percentImageSize: number = flexDirection === "row" ? percentArgUnitWidth / 4 : percentArgUnitWidth * 4 / 5;
        const bottomViewDividers: React.JSX.Element | null = flexDirection === "row" ? null : <Divider size={20} />;
        return [
            <Divider />,
            <View style={[whiteBoxStyle, { alignItems: "center", width: teacherSupportCellWidth }]}>
                <PremiumTeam screenSize={whiteBoxWidth} />
            </View>]
    }

    const renderTeacherFeedback = (): React.JSX.Element[] | null => {
        if (user.profile === "family") {
            return null
        }

        let allLogosWidth: number = whiteBoxWidth - appTheme.pixelPerfect(20);
        let percentArgWidth: number = whiteBoxWidth - appTheme.pixelPerfect(20);
        let argsPaddingHorizontal: number = 0;
        let argsPaddingVertical: number = 0;
        if (flexDirection === "row") {
            allLogosWidth = (allLogosWidth - appTheme.pixelPerfect(200)) * 2 / 5;
            percentArgWidth = (percentArgWidth - appTheme.pixelPerfect(200)) * 3 / 5;
            argsPaddingHorizontal = appTheme.pixelPerfect(10);
            argsPaddingVertical = appTheme.pixelPerfect(20);
        }
        const allLogosHeight: number = allLogosWidth * 145 / 1024;
        const allSupportsHeight: number = allLogosWidth * 980 / 1626;
        const percentArgUnitWidth: number = percentArgWidth / 3;
        const percentImageSize: number = flexDirection === "row" ? percentArgUnitWidth / 3 : percentArgUnitWidth * 4 / 5;
        const bottomViewDividers: React.JSX.Element | null = flexDirection === "row" ? null : <Divider />;
        let firstViewHeightStyle: ViewStyle | null = flexDirection === "row" ? { height: "100%" } : null;
        return [
            <Divider />,
            <View style={[whiteBoxStyle]}>
                <View style={{ width: allLogosWidth, flex: 1, justifyContent: flexDirection === "row" ? "space-evenly" : "flex-start", alignItems: flexDirection === "row" ? "flex-start" : "center", flexDirection: flexDirection }}>
                    <View key="teache_feedback_title" style={[{ paddingVertical: argsPaddingVertical, justifyContent: "space-between", width: percentArgWidth, alignItems: "center" }, firstViewHeightStyle]}>
                        <Text style={[sectionBodyStyle, { flexShrink: 1, fontSize: appTheme.pixelPerfectForFont(10), fontFamily: appTheme.primaryBoldFont, textTransform: "uppercase" }]}>{user.profile === "animator" ? translate.labels().premium.animator.feedback.title : translate.labels().premium.teacher.feedback.title}</Text>
                        <Divider />
                        <View style={{ flexDirection: "row", width: percentArgWidth }}>
                            <View style={{ flex: 1, alignItems: "center" }}>
                                <Image source={require("../../assets/img/premium/percent_ninety_two.png")} style={{ width: percentImageSize, height: percentImageSize }} />
                                <Divider />
                                <Text style={[{ paddingHorizontal: argsPaddingHorizontal, textAlign: "center", flexShrink: 1, fontFamily: appTheme.primarySemiBoldFont, fontSize: flexDirection === "row" ? appTheme.pixelPerfectForFont(9) : appTheme.pixelPerfectForFont(6), color: appTheme.darkBlue }]}>{user.profile === "animator" ? translate.labels().premium.animator.feedback.args.one : translate.labels().premium.teacher.feedback.args.one}</Text>
                            </View>
                            <View style={{ flex: 1, alignItems: "center" }}>
                                <Image source={require("../../assets/img/premium/percent_heighty_seven.png")} style={{ width: percentImageSize, height: percentImageSize }} />
                                <Divider />
                                <Text style={[{ paddingHorizontal: argsPaddingHorizontal, textAlign: "center", flexShrink: 1, fontFamily: appTheme.primarySemiBoldFont, fontSize: flexDirection === "row" ? appTheme.pixelPerfectForFont(9) : appTheme.pixelPerfectForFont(6), color: appTheme.darkBlue }]}>{user.profile === "animator" ? translate.labels().premium.animator.feedback.args.two : translate.labels().premium.teacher.feedback.args.two}</Text>
                            </View>
                            <View style={{ flex: 1, alignItems: "center" }}>
                                <Image source={require("../../assets/img/premium/percent_heighty_two.png")} style={{ width: percentImageSize, height: percentImageSize }} />
                                <Divider />
                                <Text style={[{ paddingHorizontal: argsPaddingHorizontal, textAlign: "center", flexShrink: 1, fontFamily: appTheme.primarySemiBoldFont, fontSize: flexDirection === "row" ? appTheme.pixelPerfectForFont(9) : appTheme.pixelPerfectForFont(6), color: appTheme.darkBlue }]}>{user.profile === "animator" ? translate.labels().premium.animator.feedback.args.three : translate.labels().premium.teacher.feedback.args.three}</Text>
                            </View>
                        </View>
                        <Divider />
                        <Text style={[{ textAlign: "center", flexShrink: 1, fontFamily: appTheme.primaryMediumFont, fontSize: appTheme.pixelPerfectForFont(6), color: appTheme.darkBlue }]}>{translate.labels().premium.teacher.feedback.legend}</Text>
                        {bottomViewDividers}
                    </View>
                    <Divider />
                    <View key="teache_feedback_body" style={{ width: allLogosWidth, alignItems: "center", justifyContent: "center" }}>
                        <Image source={user.profile === "animator" ? require("../../assets/img/premium/lep_all_formats.png") : require("../../assets/img/premium/lae_all_formats.png")} style={{ width: allLogosWidth, height: allSupportsHeight }} />
                        <Divider />
                        <Image source={require("../../assets/img/premium/all_logos.png")} style={{ width: allLogosWidth, height: allLogosHeight }} />
                        {bottomViewDividers}
                    </View>
                </View>
            </View>]
    }

    // FAMILY
    const renderFamilyIntro = (): React.JSX.Element | null => {
        if (user.profile !== "family") {
            return null
        }
        const header_image_height: number = Platform.OS === "web" ? appTheme.getFullAppWidth() * 483 / 4001 : appTheme.getFullAppWidth() * 1120 / 2880;
        return <Image source={require("../../assets/img/premium/lam_header.png")} style={{ width: appTheme.getFullAppWidth(), height: header_image_height }} />
    }

    const onSubscriptionConfirmed = () => {
        //Si l'abonnement est confirmé, il faut redirigé l'utilisateurs vers son compte qui a été mis à jour
        //En affichant le compte de l'utilisateur on ferme automatiquement la vue premium
        EventRegister.emitEvent("userSubUpdated", {});
    }

    const renderFamilyPlans = (): React.JSX.Element | null => {
        if (user.profile !== "family") {
            return null;
        }
        const leftView: React.JSX.Element[] | undefined = Platform.OS === "web" ? [<Image source={require("../../assets/img/premium/logo_men.png")} style={{ width: appTheme.pixelPerfect(100), height: appTheme.pixelPerfect(75) }} />] : undefined;
        const rightView: React.JSX.Element[] | undefined = Platform.OS === "web" ? undefined : [<Image source={require("../../assets/img/premium/logo_men.png")} style={{ width: appTheme.pixelPerfect(80), height: appTheme.pixelPerfect(60) }} />];
        return <View style={{ flex: 1, alignItems: "center" }}>
            <PremiumCell
                id="family_plan_intro"
                full_header={false}
                title_font={appTheme.primaryBoldFont}
                title_uppercase={false}
                title={translate.labels().premium.family.plans.intro.title}
                number_of_cell={1}
                gap={0.01}
                screenWidth={Platform.OS === "web" ? appTheme.getBlockWidth() : whiteBoxWidth}
                flexDirection={flexDirection}
                leftView={leftView}
                rightView={rightView}
                button={{
                    title: translate.labels().premium.family.plans.intro.button,
                    action: launchSubscriptionPage
                }} />
            <PremiumCell
                id="family_plan_details"
                full_header={false}
                title_font={appTheme.primaryBoldFont}
                title_uppercase={false}
                number_of_cell={1}
                gap={0.01}
                screenWidth={Platform.OS === "web" ? appTheme.getBlockWidth() : whiteBoxWidth}
                flexDirection={flexDirection}
                extraComponent={[
                    <PremiumArguments />,
                    <PremiumSubBlock
                        onSubscriptionConfirmed={onSubscriptionConfirmed}
                        onPlanSelection={(plan: PurchasesPackage) => setPlanSelected(plan)} />
                ]} />
        </View>
    }

    // TEACHER AND ANIMATOR
    const renderTeacherIntro = () => {
        if (user.profile === "family") {
            return <View />
        }

        let photoViewForWeb: React.JSX.Element | null = null;
        let allLogosWidth: number = whiteBoxWidth - appTheme.pixelPerfect(30);
        if (flexDirection === "row") {
            const photoToDisplay: number = user.profile === "animator" ? require("../../assets/img/rooms/photo_lep_room_anims.png") : require("../../assets/img/rooms/photo_emilie.jpg");
            allLogosWidth = (allLogosWidth - appTheme.pixelPerfect(190)) / 2;
            photoViewForWeb = <View style={{ justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Image source={photoToDisplay} style={{ borderRadius: appTheme.pixelPerfect(18), width: appTheme.pixelPerfect(200), height: appTheme.pixelPerfect(150) }} />
            </View>
        }
        const allLogosHeight: number = allLogosWidth * 145 / 1024;
        const bottomViewDividers: React.JSX.Element | null = flexDirection === "row" ? null : <Divider />;
        return <View style={[whiteBoxStyle]}>
            <View style={{ flex: 1, justifyContent: flexDirection === "row" ? "center" : "flex-start", alignItems: flexDirection === "row" ? "flex-start" : "center", flexDirection: flexDirection }}>
                {photoViewForWeb}
                <View key="teache_intro_title" style={{ flex: 1, alignItems: "center", justifyContent: "center", height: "100%" }}>
                    <Text style={[sectionBodyStyle, { flexShrink: 1, fontSize: appTheme.pixelPerfectForFont(10), fontFamily: appTheme.primaryBoldFont }]}>{translate.labels().premium.teacher.minister_section.title}</Text>
                    <Divider />
                    <Text style={[sectionBodyStyle, { textAlign: "center", flexShrink: 1, fontFamily: appTheme.primaryMediumFont }]}>{translate.labels().premium[user.profile].minister_section.chapo}</Text>
                    {bottomViewDividers}
                </View>
                <View key="teache_intro_body" style={{ flex: 1, alignItems: "center", justifyContent: "center", height: "100%" }}>
                    <Text style={[sectionBodyStyle, { flexShrink: 1, fontFamily: appTheme.primaryMediumFont }]}>{translate.labels().premium.teacher.minister_section.body}</Text>
                    <Divider />
                    <View style={{ alignItems: "center" }}>
                        <Image source={require("../../assets/img/premium/all_logos.png")} style={{ width: allLogosWidth, height: allLogosHeight }} />
                    </View>
                    {bottomViewDividers}
                </View>
            </View>
        </View>
    }

    const renderTitle = (item: { title: string; icon: number; }) => {
        const { title, icon } = item;
        return <View style={{ width: whiteBoxWidth, flexDirection: "row", justifyContent: "center", alignItems: "center", marginVertical: appTheme.pixelPerfect(10) }}>
            <Image source={icon} style={{ width: appTheme.pixelPerfect(32), height: appTheme.pixelPerfect(32), marginRight: appTheme.pixelPerfect(5) }} />
            <Text style={[{ flexShrink: 1, color: user.profile === "family" ? "#FFFFFF" : appTheme.darkBlue, textAlign: "center", textTransform: "uppercase", fontFamily: appTheme.primaryBoldFont, paddingHorizontal: 0, fontSize: appTheme.pixelPerfectForFont(10) }]}>
                {title}
            </Text>
        </View>
    }

    const renderPlanCell = (item: { id: string; header: number; title: string; body: string; number_of_cell: number; gap: number; full_header?: boolean; backgroundColor?: string; textColor?: string; title_font?: string; button: { title: string; action: () => void }; extraComponent?: React.JSX.Element[] }) => {
        const { id, header, title, body, button, extraComponent = null, number_of_cell, gap, backgroundColor = "#FFFFFF", textColor = appTheme.darkBlue, full_header = true, title_font = appTheme.superHerosFontBold } = item;
        const cellWidth: number = flexDirection === "column" ? whiteBoxWidth : (whiteBoxWidth * ((1 - ((number_of_cell - 1) * gap))) / number_of_cell);
        return <View key={id} style={[whiteBoxStyle, { backgroundColor, paddingHorizontal: 0, width: cellWidth, paddingVertical: full_header === true ? 0 : flexDirection === "column" ? appTheme.pixelPerfect(10) : appTheme.pixelPerfect(20), paddingBottom: appTheme.pixelPerfect(20), marginVertical: appTheme.pixelPerfect(10) }]}>
            <View style={{ flex: 1, alignItems: "center" }}>
                <Image resizeMode={full_header === true ? "cover" : "contain"} source={header} style={{ width: full_header === true ? cellWidth : Platform.OS === "web" ? cellWidth - appTheme.pixelPerfect(120) : cellWidth - appTheme.pixelPerfect(60), height: Platform.OS === "web" ? appTheme.pixelPerfect(120) : appTheme.pixelPerfect(80) }} />
                <Divider />
                <Text style={[sectionTitleStyle, { color: textColor, width: cellWidth, fontFamily: title_font, fontSize: appTheme.pixelPerfectForFont(10), textTransform: "uppercase" }]}>{title}</Text>
                <Divider />
                <Text style={[sectionBodyStyle, { color: textColor, fontFamily: appTheme.primaryMediumFont }]}>{body}</Text>
                <Divider />
                {extraComponent}
                <Divider />
                <View style={{ flex: 1, justifyContent: "flex-end" }}>
                    <Button title={button.title} onPress={button.action} textStyle={{ color: appTheme.darkBlue, fontSize: Platform.OS === "web" ? appTheme.pixelPerfectForFont(7) : appTheme.pixelPerfectForFont(8) }} style={{ width: cellWidth - appTheme.pixelPerfect(20), height: appTheme.pixelPerfect(36), paddingVertical: appTheme.pixelPerfect(4), backgroundColor: "#FFD77A" }} />
                </View>
            </View>
        </View>
    }

    const getFullProgramCells = (item: { number_of_cell: number; gap: number; }) => {
        const { number_of_cell, gap } = item;
        const cellWidth: number = flexDirection === "column" ? whiteBoxWidth : (whiteBoxWidth * ((1 - ((number_of_cell - 1) * gap))) / number_of_cell);
        const blockByLine: number = flexDirection === "column" ? 2 : cellWidth > 600 ? 3 : 2;
        const cellBlockWidth: number = (cellWidth - appTheme.pixelPerfect(36)) / blockByLine;
        const cellBlockSubjects: string[] = [
            "Compétences\npsychosociales",
            "Bien-être et\nsanté mentale",
            "Prévention\ndu harcèlement",
            "Egalité\nfilles-garçons",
            "Compétences\nlangagières",
            "Inclusion et\ncitoyenneté"
        ];
        let blockRows: React.JSX.Element[] = [];
        let blockLines: React.JSX.Element[] = [];
        for (const aSubject of cellBlockSubjects) {
            blockLines.push(<View key={aSubject} style={{ paddingVertical: appTheme.pixelPerfect(10), justifyContent: "center", alignItems: "center", paddingHorizontal: appTheme.pixelPerfect(10), backgroundColor: appTheme.darkBlue, borderRadius: appTheme.pixelPerfect(14), width: cellBlockWidth, marginHorizontal: appTheme.pixelPerfect(2) }}>
                <Text style={{ color: "#FFFFFF", textAlign: "center", fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(7) }}>{aSubject}</Text>
            </View>)
            if (blockLines.length === blockByLine) {
                blockRows.push(<View key={`line_${blockRows.length}`} style={{ flexDirection: "row", width: cellWidth, justifyContent: "center", marginVertical: appTheme.pixelPerfect(2) }}>
                    {blockLines}
                </View>);
                blockLines = [];
            }
        }
        if (blockLines.length > 0) {
            blockRows.push(<View key={`line_${blockRows.length}`} style={{ flexDirection: "row", width: cellWidth, justifyContent: "center", marginVertical: appTheme.pixelPerfect(2) }}>
                {blockLines}
            </View>);
        }
        return blockRows;
    }

    const renderAnimatorIntroBulletPoint = (): React.JSX.Element[] => {
        let introBulletPoints: React.JSX.Element[] = [];
        let bulletPoints: string[] = [
            translate.labels().premium.animator.plans.intro.bullet.one,
            translate.labels().premium.animator.plans.intro.bullet.two,
            translate.labels().premium.animator.plans.intro.bullet.three,
            translate.labels().premium.animator.plans.intro.bullet.four,
            translate.labels().premium.animator.plans.intro.bullet.five
        ];
        for (const bullet of bulletPoints) {
            introBulletPoints.push(<View key={bullet} style={{ flexDirection: "row", paddingBottom: 10, justifyContent: "flex-start", alignItems: "center", width: "90%" }}>
                <Image source={require("../../assets/img/premium/ic_bullet.png")} style={{ width: appTheme.pixelPerfect(20), height: appTheme.pixelPerfect(20), marginEnd: appTheme.pixelPerfect(10) }} />
                <Text style={{ flexShrink: 1, color: "#FFFFFF", fontFamily: appTheme.primarySemiBoldFont, fontSize: appTheme.pixelPerfectForFont(7) }}>{bullet}</Text>
            </View>)
        }

        return introBulletPoints;
    }

    const renderAnimatorPlans = (): (React.JSX.Element | null)[] | null => {
        if (user.profile === "animator") {
            return [
                <PremiumCell
                    id="animator_plan_intro"
                    full_header={false}
                    title_font={appTheme.primaryBoldFont}
                    title_uppercase={false}
                    title={translate.labels().premium.animator.plans.intro.title}
                    backgroundColor="#57537F"
                    textColor="#FFFFFF"
                    number_of_cell={3}
                    gap={0.01}
                    screenWidth={whiteBoxWidth}
                    flexDirection={flexDirection}
                    extraComponent={renderAnimatorIntroBulletPoint()}
                    button={{
                        title: translate.labels().premium.animator.plans.acm.button,
                        action: onContactRequest
                    }} />,
                <PremiumCell
                    id="teacher_licence"
                    header={require("../../assets/img/premium/lep_vignette_premium-acm.png")}
                    title={translate.labels().premium.animator.plans.acm.title}
                    body={translate.labels().premium.animator.plans.acm.body}
                    number_of_cell={3}
                    gap={0.01}
                    screenWidth={whiteBoxWidth}
                    flexDirection={flexDirection}
                    button={{
                        title: translate.labels().premium.animator.plans.acm.button,
                        action: onContactRequest
                    }} />,
                <PremiumCell
                    id="full_program"
                    header={require("../../assets/img/premium/lae_vignette_premium_parcours_complet.png")}
                    title={translate.labels().premium.teacher.plans.complet_program.title}
                    body={translate.labels().premium.animator.plans.complet_program.body}
                    number_of_cell={3}
                    gap={0.01}
                    screenWidth={whiteBoxWidth}
                    flexDirection={flexDirection}
                    button={{
                        title: translate.labels().premium.animator.plans.acm.button,
                        action: onContactRequest
                    }}
                    extraComponent={getFullProgramCells({ number_of_cell: 3, gap: 0.01 })} />
            ]
        }
        return null;
    }

    const renderPlansTitle = (): React.JSX.Element | null => {
        if (user.profile === "family") {
            return null;
        }
        return renderTitle({ title: translate.labels().premium.our_plans, icon: require("../../assets/img/premium/picto_formule.png") });
    }

    const renderTeacherPlans = (): React.JSX.Element[] | null => {
        if (user.profile === "teacher") {
            /*

                    extraComponent={[
                        <Button link title={translate.labels().premium.teacher.plans.teacher.extra} />,
                        <Divider />
                    ]} />,
                     */
            return [
                <PremiumCell
                    id="teacher_licence"
                    header={require("../../assets/img/premium/lae_vignette_premium_enseignant.png")}
                    title={translate.labels().premium.teacher.plans.teacher.title}
                    body={translate.labels().premium.teacher.plans.teacher.body}
                    number_of_cell={3}
                    gap={0.01}
                    screenWidth={whiteBoxWidth}
                    flexDirection={flexDirection}
                    button={{
                        title: translate.labels().premium.teacher.plans.teacher.button,
                        action: launchSubscriptionPage
                    }} />,
                <PremiumCell
                    id="school_licence"
                    header={require("../../assets/img/premium/lae_vignette_premium_etablissement.png")}
                    title={translate.labels().premium.teacher.plans.school.title}
                    body={translate.labels().premium.teacher.plans.school.body}
                    number_of_cell={3}
                    gap={0.01}
                    screenWidth={whiteBoxWidth}
                    flexDirection={flexDirection}
                    button={{
                        title: translate.labels().premium.teacher.plans.school.button,
                        action: onContactRequest
                    }} />,
                <PremiumCell
                    id="full_program"
                    header={require("../../assets/img/premium/lae_vignette_premium_parcours_complet.png")}
                    title={translate.labels().premium.teacher.plans.complet_program.title}
                    body={translate.labels().premium.teacher.plans.complet_program.body}
                    number_of_cell={3}
                    gap={0.01}
                    screenWidth={whiteBoxWidth}
                    flexDirection={flexDirection}
                    button={{
                        title: translate.labels().premium.teacher.plans.school.button,
                        action: onContactRequest
                    }}
                    extraComponent={getFullProgramCells({ number_of_cell: 3, gap: 0.01 })} />
            ]
        }
        return null;
    }

    const renderPremiumCard = (): React.JSX.Element => {
        return <View style={{ alignItems: "center" }}>
            {renderTitle({ title: translate.labels().premium.cards, icon: require("../../assets/img/premium/picto_carte_premium.png") })}
            <Divider />
            {renderPlanCell({
                id: "premium_card",
                header: require("../../assets/img/premium/lae_vignette_premium_card.png"),
                title: translate.labels().premium.premium_cards.title,
                body: translate.labels().premium.premium_cards.body,
                number_of_cell: 2,
                gap: 0.01,
                backgroundColor: "#726DA5",
                textColor: "#FFFFFF",
                button: {
                    title: translate.labels().premium.premium_cards.button,
                    action: () => setShowPremiumCardForm(true)
                }
            })}
        </View>
    }

    const renderProgramFinancePossibilities = (): React.JSX.Element[] | null => {
        if (user.profile === "family") {
            return null;
        }
        return [<Divider />,
        renderTitle({ title: translate.labels().premium.finance, icon: require("../../assets/img/premium/picto_euro.png") }),
        <View style={{ flexDirection, gap: whiteBoxWidth * 0.01 }}>
            {renderPlanCell({
                id: "district_finance",
                header: require("../../assets/img/premium/logos_qpv_cites_ter.png"),
                title: translate.labels().premium.teacher.finance.district.title,
                title_font: appTheme.primaryBoldFont,
                body: translate.labels().premium.teacher.finance.district.body,
                full_header: false,
                number_of_cell: 2,
                gap: 0.01,
                button: {
                    title: translate.labels().premium.teacher.finance.district.button,
                    action: onContactRequest
                }
            })}
            {renderPlanCell({
                id: "other_finance",
                header: require("../../assets/img/premium/logos_amct_caf_ars.png"),
                title: translate.labels().premium.teacher.finance.divers.title,
                title_font: appTheme.primaryBoldFont,
                body: translate.labels().premium.teacher.finance.divers.body,
                full_header: false,
                number_of_cell: 2,
                gap: 0.01,
                button: {
                    title: translate.labels().premium.teacher.finance.divers.button,
                    action: onContactRequest
                }
            })}
        </View>]
    }

    return <SafeAreaView style={{ backgroundColor: appTheme.getBackgroundColor("dark"), width: appTheme.getFullAppWidth(), alignItems: "center", flex: 1 }}>
        <View style={{ width: appTheme.getFullAppWidth(), alignItems: "center" }}>
            <NavBarTitle titleColor={user.profile === "family" ? "#FFFFFF" : appTheme.darkBlue} title={i18n.t(`premium.title.${user.profile}`)} showLevel={false} />
        </View>
        <ScrollView showsVerticalScrollIndicator={false} style={{ flex: 1, backgroundColor: appTheme.getBackgroundColor("light") }}>
            <View style={{ alignItems: "center" }}>
                {renderFamilyIntro()}
                {renderTeacherIntro()}
                <Divider />
                {renderPlansTitle()}
                <View style={{ flexDirection, gap: whiteBoxWidth * 0.01, justifyContent: "center" }}>
                    {renderTeacherPlans()}
                    {renderAnimatorPlans()}
                </View>
                {renderFamilyPlans()}
                {renderTeacherFeedback()}
                {renderProgramFinancePossibilities()}
                {renderTeacherSupport()}
                <Divider />
                {renderPremiumCard()}
            </View>
            <View style={{ height: appTheme.pixelPerfect(100) }} />
        </ScrollView>
        <Modal
            style={{ flex: 1 }}
            transparent={true}
            presentationStyle="overFullScreen"
            animationType="slide"
            visible={showPremiumCardForm}>
            <View style={{ flex: 1, width: appTheme.getFullScreenWidth(), alignItems: "center", justifyContent: "center" }}>
                {getCardDetailsModalContent()}
            </View>
        </Modal>
    </SafeAreaView>

}

export default PremiumScreen;

const styles = StyleSheet.create({
    inside_block: {

    }
});